import { useState } from "react";
import { useTranslation } from "react-i18next";
import { putUser } from "store/thunks";
import { toast } from "react-toastify";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";

const CheckboxStatusUser = ({ item, isDisabled }: { item: any, isDisabled?: boolean }) => {
  const { t, i18n } = useTranslation();

  const [itemActiveStatusUser, setItemActiveStatusUser] = useState<any>(null);

  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    is_active: number | boolean;
  }) => {
    try {
      if (!item) {
        return;
      }
      const response: any = await putUser(item?.id, {
        is_active: item?.is_active,
      });
      
      if (response?.statusCode === 200) {
        setItemActiveStatusUser({
          id: item?.id,
          is_active: item?.is_active,
        });

        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

//   useEffect(() => {
//     if (item) {
//       setItemActiveStatusUser({
//         is_active: item?.is_active,
//         id: item?.id,
//       });
//     }
//   }, [item]);

  return (
    <div
      className="form-check form-switch form-switch-sm text-center"
      dir="ltr"
      // style={{ width: 80 }}
    >
      <input
        type="checkbox"
        className="form-check-input"
        name="is_active"
        checked={itemActiveStatusUser ? itemActiveStatusUser?.is_active : item?.is_active}
        disabled={item?.is_deleted === 1}
        onChange={(e) => {
          if(isDisabled) return;

          const value = e?.target?.checked;
          handleOnConfirmUpdate({
            id: item?.id,
            is_active: !!value ? 1 : 0,
          });
        }}
      />
      {
        item?.is_deleted === 1 && (
          <div>
            <small className="text-danger">{t('Deleted')}</small>
          </div>
        )
      }
    </div>
  );
};

export default CheckboxStatusUser;
